import { FC } from "react";
import Layout from "@/components/layout";
import styles from "./LoadingScreen.module.scss";

const LoadingScreen: FC = () => {
  return (
    <Layout childrenClassName={styles.container} data-cy="loading-screen">
      <div className={styles.loader}></div>
    </Layout>
  );
};

export default LoadingScreen;
